module.exports = __webpack_public_path__ + "img/icone_mapa_comfotos copy.0b1a2004.png";